import { useEffect } from 'react';
export const useOnRoomReconnecting = (room, onError) => {
    useEffect(() => {
        if (!room)
            return;
        const onReconnecting = (error) => {
            if (error)
                onError(error);
        };
        room.on('reconnecting', onReconnecting);
        return () => {
            room.off('reconnecting', onReconnecting);
        };
    }, [room, onError]);
};
//# sourceMappingURL=useOnRoomReconnecting.js.map